import { 
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { auth } from './firebase';

// Admin-Login
export const loginAdmin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // Token neu laden um Custom Claims zu bekommen
    await user.getIdToken(true);
    const idTokenResult = await user.getIdTokenResult();
    
    // Prüfen ob User Admin-Rechte hat
    if (idTokenResult.claims.admin === true) {
      return { success: true, user };
    } else {
      // Kein Admin → Ausloggen
      await signOut(auth);
      return { success: false, error: 'Keine Admin-Berechtigung' };
    }
  } catch (error) {
    console.error('❌ Login-Fehler:', error);
    return { success: false, error: error.message };
  }
};

// Admin-Logout
export const logoutAdmin = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    console.error('❌ Logout-Fehler:', error);
    return { success: false, error: error.message };
  }
};

// Prüft ob aktueller User Admin ist
export const checkAdminAuth = (callback) => {
  return onAuthStateChanged(auth, async (user) => {
    if (user) {
      const idTokenResult = await user.getIdTokenResult();
      const isAdmin = idTokenResult.claims.admin === true;
      callback({ isAdmin, user });
    } else {
      callback({ isAdmin: false, user: null });
    }
  });
};